import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

//import { Editor } from '@tinymce/tinymce-react';
import SimpleReactValidator from 'simple-react-validator';
import { getRoleListV1, commonAPI, adminUser } from '../../API/FetchCall';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class bewiseUsersEdit extends Component {

    constructor(props) {
      
        super(props);
        this.state = {
          menu_list: [],
          locationList: [],
          showPassword: false,
          showCPassword: false,
          errors: [],
          user_name: '',
          email_id: '',
          location: '',
          role: '',
          password: '',
          confirm_password: '',
          login_id: this.props.match.params.id ? this.props.match.params.id : ''
        };
        
        this.id = this.props.match.params.id ? this.props.match.params.id : '';

        this.validator = new SimpleReactValidator({
          validators: {
            confirmpassword: {  // name the rule
              message: 'The :attribute must be Same as Password.',
              rule: (val, params, validator) => {
                if (val != this.state.password) {
                  return false;
                }
              },
              messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
              required: true  // optional
            }
          }
        });

    }


  EditSubuser() {

    let ins = JSON.stringify({
      login_id: this.id,
      url: 'editUser'
    });
     
      adminUser(ins).then((res) => {
        if (res.status == 1) {
          console.log('res', res.data)
          this.setState({
            user_name: res.data.user_name,
            email_id: res.data.email_id,
            location: res.data.city,
            role: res.data.role,
          });
        }
      });
     

  }

  UNSAFE_componentWillMount() { }

  componentDidMount() {
    this.RoleDataList();
    this.getLocation();
    this.EditSubuser();

  }

  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }  

  handleShowPassword() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }
  handleShowCPassword() {
    this.setState((prevState) => ({
      showCPassword: !prevState.showCPassword,
    }));
  }

  RoleDataList = async () => {
    try {
      const res = await getRoleListV1();
      if (res.status == 1) {
        console.log('res.results', res.list)
        this.setState({
          menu_list: res.list,
          error: false
        });
      }
    } catch (error) {
      this.setState({ error: true });
    }
  };
 
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
 
 
  getLocation = () => {
    let req = JSON.stringify({
      url: 'location_list'
    });
    commonAPI(req).then(res => {
      if (res.status === 1) {
        this.setState({
          locationList: res.list
        })
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let toastr = '';
    if (this.validator.allValid()) {
      let insert = JSON.stringify({
        user_name: this.state.user_name,
        email_id: this.state.email_id,
        password: this.state.password,
        location: this.state.location,
        role: this.state.role,
        login_id: this.state.login_id ? this.state.login_id : '',
        url: 'adduser_data'
      });

      adminUser(insert).then((response) => {
        if (response.status == 1) {
          

          NotificationManager.success(response.message);

          setTimeout(function () {
            window.location.replace('/users/bewiseusers');
          }, 1000);
        } else {

          NotificationManager.error(response.message);

          
          setTimeout(function () {
          }, 1000);
        }
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
  
    this.validator.purgeFields();
        return (
            <React.Fragment>
                <AdminLayout>
                    
             <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">User - Edit</h4>
                    
                   <div id="company-info">
                      <form
                        encType="multipart/form-data"
                        method="post"
                        onSubmit={this.handleSubmit}
                        autoComplete="off"
                        className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no"
                      >
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label>
                                Name<span className="astrick">*</span>
                              </label>
                              <input

                                type="text"
                                className="form-control"
                                name="user_name"
                                autocomplete="off"
                                value={this.state.user_name}
                                onChange={this.handleChange}
                              />
                              
                            </div>
                            <div className="form-group col-md-4">
                              <label>
                                Email Id<span className="astrick">*</span>
                              </label>
                              <input

                                type="email"
                                className="form-control"
                                name="email_id"
                                autocomplete="off"
                                value={this.state.email_id}
                                onChange={this.handleChange}
                              />
                              
                            </div>
                            <div className="form-group col-md-4">
                              <label>
                                Location
                                <span className="astrick">*</span>
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  name="location"
                                  id="location"
                                  autocomplete="off"
                                  onChange={this.handleSelect}
                                  value={this.state.location}
                                  className="form-control selectpicker" title='Select'>
                                  {this.state.locationList.length > 0 &&
                                    this.state.locationList.map((item, i) => {
                                      return (
                                        <option value={item.location} >
                                          {item.location}
                                        </option>
                                      )
                                    })}

                                </select>
                              </div>
                            </div>
                            <div className="form-group col-md-4">
                              <label>
                                Role
                                <span className="astrick">*</span>
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  name="role"
                                  id="role"
                                  onChange={this.handleSelect}
                                  value={this.state.role}
                                  autocomplete="off"
                                  className="form-control selectpicker" title='Select'>
                                  {this.state.menu_list.length > 0 &&
                                    this.state.menu_list.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.role}
                                        </option>
                                      )
                                    })}

                                </select>
                               
                              </div>
                            </div> <div className="form-group col-md-4">
                              <label>
                                Password <span className="astrick">*</span>
                              </label>
                              <input
                                type={this.state.showPassword ? 'text' : 'password'}
                                name="password"
                                value={this.state.password}
                                autocomplete="off"
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              <span
                                toggle='#password-field'
                                className={this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin'}
                                onClick={() => {
                                  this.handleShowPassword();
                                }}
                              ></span>
                              
                            </div>
                            <div className="form-group col-md-4">
                              <label>
                                Confirm Password <span className="astrick">*</span>
                              </label>
                              <input
                                type={this.state.showCPassword ? 'text' : 'password'}
                                name="confirm_password"
                                autocomplete="off"
                                value={this.state.confirm_password}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              <span
                                toggle='#password-field'
                                className={this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin'}
                                onClick={() => {
                                  this.handleShowCPassword();
                                }}
                              ></span>
                             
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 col-xs-12 btn-bdr">
                          <button id="btnSubmit" className="btn btn-primary btn-sm">Submit</button>
                        </div>
                      </form>
                    </div>


                </div>
              </div>
            </div>  
            <NotificationContainer/>
                 

                </AdminLayout>
            </React.Fragment>
        )
    }
}



export default bewiseUsersEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/bewiseUsersEdit.jsx